module.exports = __webpack_public_path__ + "img/ic-lianlian.897a5296.svg";